import React from 'react';

const LocationResults = props => {
  return (
    <div className="locations-results--wrapper">
      <p className="results-count">{props.resultsCountText}</p>
      <div className="location-results-card--container" />
    </div>
  );
};

export default LocationResults;
